'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_OrganizationReadResponse(orgInfo, documentsIssued, documentsReceived) {
  this.qE = null;
  this.KA = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.KB = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  this.qE = orgInfo;
  this.KA = documentsIssued;
  this.KB = documentsReceived;
}
export { $c_Lapp_api_OrganizationReadResponse as $c_Lapp_api_OrganizationReadResponse };
$p = $c_Lapp_api_OrganizationReadResponse.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_OrganizationReadResponse;
/** @constructor */
function $h_Lapp_api_OrganizationReadResponse() {
}
export { $h_Lapp_api_OrganizationReadResponse as $h_Lapp_api_OrganizationReadResponse };
$h_Lapp_api_OrganizationReadResponse.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().Y(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("OrganizationReadResponse"));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().Y(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().aE(this.qE));
  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.KA;
  acc = $x_2.Y($x_1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().rG(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(t.i, t.j)));
  var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$();
  var $x_3 = acc;
  var t$1 = this.KB;
  acc = $x_4.Y($x_3, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().rG(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(t$1.i, t$1.j)));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().c9(acc, 3);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_OrganizationReadResponse)) {
    var this$1 = this.KA;
    var b = x$0.KA;
    if (((this$1.i === b.i) && (this$1.j === b.j))) {
      var this$2 = this.KB;
      var b$1 = x$0.KB;
      var $x_1 = ((this$2.i === b$1.i) && (this$2.j === b$1.j));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x = this.qE;
      var x$2 = x$0.qE;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 3;
});
$p.t = (function() {
  return "OrganizationReadResponse";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.qE;
      break;
    }
    case 1: {
      return this.KA;
      break;
    }
    case 2: {
      return this.KB;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "orgInfo";
      break;
    }
    case 1: {
      return "documentsIssued";
      break;
    }
    case 2: {
      return "documentsReceived";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_api_OrganizationReadResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ix)));
}
export { $isArrayOf_Lapp_api_OrganizationReadResponse as $isArrayOf_Lapp_api_OrganizationReadResponse };
var $d_Lapp_api_OrganizationReadResponse = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_OrganizationReadResponse, "app.api.OrganizationReadResponse", ({
  ix: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_api_OrganizationReadResponse as $d_Lapp_api_OrganizationReadResponse };
//# sourceMappingURL=app.api.-Organization-Read-Response.js.map
